import { render, staticRenderFns } from "./TxnSummaryDashboard.vue?vue&type=template&id=9ce826e2&"
import script from "./TxnSummaryDashboard.vue?vue&type=script&lang=ts&"
export * from "./TxnSummaryDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports